<template>
  <div id='loading'>
     {{ msg }}
     <button>123</button>
  </div>
</template>

<script>
export default {
  name: 'HelloI18n',
  props: {
        msg: {
          type: String,
          default: "loading..."
        }
  }
}
</script>
